import { periodNameSchema } from '@common/neo.tax';
import { useParams } from 'react-router-dom';

import { PeriodName } from '../graphql';
import { toGqlPeriodName } from '../utils';

export const useSelectedPeriodNameOptional = (): PeriodName | null => {
  const { periodName } = useParams();
  if (!periodName) {
    return null;
  }
  const { data, success } = periodNameSchema.safeParse(periodName);
  if (!success) {
    return null;
  }
  return toGqlPeriodName(data);
};
